<template>
  <div class="isStylePageContent isPaddingBottom">
    <el-form ref="form" :model="submitData" :rules="formRules" label-position="top"
      :class="[$style.form]">
      <el-row style="border-bottom: #dcdfe6 1px solid; margin-bottom: 20px">
        <el-col :span="24">
          <div class="inline-between text-text" style="margin-top: 20px; margin-bottom: 20px; padding-right: 40px">
            <span>是否開放上架？</span>
            <el-switch v-model="submitData.state" active-text="是" inactive-text="否" :active-value="1"
              :inactive-value="0"></el-switch>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="名稱" required prop="title">
            <el-input v-model="submitData.title" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="類別" required prop="petCategoryTitle">
            <el-select v-model="submitData.petCategoryTitle">
              <el-option v-for="option in leafOption" :key="option.id" :value="option.categoryTitle"
                :label="option.categoryTitle"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24" :sm="24">
          <el-form-item label="商品貨號" required prop="no">
            <el-input v-model.lazy="submitData.no" class="isStyleButton" @blur="changePetSizeNo">
              <el-button slot="append" type="primary" class="is-round" @click="generateNo">自動產生貨號</el-button>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24" :sm="24">
          <el-form-item label="商品標籤" :class="[$style.productTagsStyle, $style.goodsTagStyle]">
            <el-select v-model="goodsTagsValue" multiple filterable allow-create default-first-option
              placeholder="請選擇商品標籤">
              <el-option v-for="item in goodsTagsOption" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="商品簡介" required prop="description">
            <el-input v-model="submitData.description" class="bg-white is-border is-round" type="textarea"
              :autosize="{ minRows: 4 }" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="注意事項">
            <el-input v-model="submitData.notice" class="bg-white is-border is-round" type="textarea"
              :autosize="{ minRows: 4 }" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :class="$style.eachRow" :gutter="24">
        <el-col :span="12">
          <el-form-item>
            <FileUpload v-model="submitData.images" type="service" :class="$style.upload" :show-upload="true"
              :resource="'product'" :model-source="'goods'" :immediate-delete="false"></FileUpload>
          </el-form-item>
        </el-col>
        <el-col :span="12" :class="$style.rightText">
          <el-form-item>
            <p>圖檔最大 2 MB，檔案格式限 JPG 或 PNG</p>
            <p>圖片比例：16:9，建議尺寸：800*450px</p>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="titleAndBtnDisplay">
            <h4>規格設定</h4>
            <el-button type="primary" class="is-round" @click="addNewSpec">+ 新增規格</el-button>
          </div>
        </el-col>
        <el-col v-for="(eachSpec, eachIndex) in submitData.spec" :key="`spec${eachIndex}`" :span="24">
          <div class="formatContentSet">
            <p>規格{{ eachIndex + 1 }}</p>
            <el-form-item class="typeSelect">
              <el-input v-model="eachSpec.title"> </el-input>
            </el-form-item>
            <el-form-item class="tagsSelect" :class="$style.tagsGlobalSet">
              <el-tag v-for="tag in eachSpec.values" :key="tag.alias" closable :disable-transitions="false"
                @close="handleClose(tag, eachSpec)">
                {{ tag.title }}
              </el-tag>
              <el-input v-if="eachSpec['inputVisible']" ref="saveSpecInput" v-model="specInputValue" class="input-new-tag"
                @keyup.enter.native="handleSpecConfirm(eachSpec, eachIndex)"
                @blur="handleSpecConfirm(eachSpec, eachIndex)">
              </el-input>
              <el-button v-else class="button-new-tag" size="small" @click="showSpecInput(eachSpec, eachIndex)">+
                新增規格</el-button>
            </el-form-item>
            <el-form-item :class="$style.btnDelete">
              <el-button @click="deleteSpec(eachSpec)">
                <BaseIcon name="xmark" />
              </el-button>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="24">
          <el-button class="is-round fullWidthBtn" :disabled="!submitData.id" @click="openEditImgDialog">
            編輯選項圖片
          </el-button>
        </el-col>
      </el-row>
    </el-form>
    <!-- 編輯選項圖片，跳窗 -->
    <el-dialog title="編輯選項圖片" :visible.sync="editImg" width="60%" top="0" append-to-body>
      <p>
        上傳圖片來作為規格選項，圖檔最大 2 MB，檔案格式限 JPG 或
        PNG。圖片比例：16：9，建議尺寸：800*450px
      </p>
      <el-table :data="editImgData" :class="$style.imgDialog">
        <el-table-column v-slot="{ row }" label="規格選項" min-width="200">
          {{ composeSeparateSpecString(row.separateSpecArr) }}
        </el-table-column>
        <el-table-column v-slot="{ row }" label="圖片" min-width="200">
          <SingleFileUpload v-model="row.params.images" type="goods" :class="$style.upload" :show-upload="true"
            :resource="'product'" :immediate-delete="false"></SingleFileUpload>
        </el-table-column>
      </el-table>
      <div class="btn-group-inline">
        <el-button class="is-round" @click="cancelSelectProducts">取消</el-button>
        <el-button class="is-round" type="primary" @click="saveSelectProducts">儲存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import lazyLoadComponent from "@router/lazyload-component";
import goodsMixin from "@/src/mixins/goodsMixin";
export default {
  name: "TabInfoInCommodity",
  components: {
    FileUpload: () => lazyLoadComponent(import("@views/chat/components/FileUpload")),
    SingleFileUpload: () =>
      lazyLoadComponent(import("@views/chat/components/SingleFileUpload")),
  },
  mixins: [goodsMixin],
  props: {
    /**
     * @description 所有分店
     */
    products: {
      type: Array,
      required: true,
    },
    /**
     * @description 預設顯示資料
     */
    defaultValue: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      submitData: {
        no: "",
        petCategoryTitle: "",
        title: "",
        description: "",
      },
      editImgData: [], // 開啟編輯圖片時的畫面資料
      oldSubmitDataNo: "",
      exportType: "",
      tagInput: "", // 用來綁定輸入框的資料
      tags: [], // 用來儲存標籤的陣列
      dynamicTags: [], // 動態新增標籤（已存在的標籤
      inputVisible: false, //
      inputValue: "", // 手動輸入的input標籤
      specInputValue: "", // 手動輸入的spec文字
      editImg: false, // 編輯選項圖片
      treeData: [], // 樹形下拉選單
      goodsTagsOption: [],
      goodsTagsValue: [], // 標籤的值
      leafOption: [], // 子節點的值
      mountedStatus: false, // mounted的狀態
      formRules: {
        title: [
          {
            required: true,
            message: "請輸入商品名稱",
          },
        ],
        petCategoryTitle: [
          {
            required: true,
            message: "請輸入類別",
          },
        ],
        no: [
          {
            required: true,
            message: "請輸入貨號",
          },
        ],
        description: [
          {
            required: true,
            message: "請輸入商品描述",
          },
        ],
      },
    };
  },
  provide() { },
  inject: [],
  computed: {
    /**
     * @description 新增 or 修改模式
     */
    isEditMode() {
      return this.defaultValue.id;
    },
  },
  watch: {
    /**
     * @description 如果沒有舊的標籤，要取打API新增標籤的邏輯
     */
    goodsTagsValue: {
      async handler(nvl, ovl) {
        // 如果是新增標籤要去打API
        if (nvl.length > ovl.length) {
          const newItemValue = nvl[nvl.length - 1];
          const isExist = this.goodsTagsOption.find(
            (item) => item.value === newItemValue
          );
          if (!isExist) {
            await this.$store.dispatch("mixTag/mixTagStore", {
              title: newItemValue,
              type: "goods",
            });
            await this.fetchTagsName();
          }
        }
        // 以下是更新選到的tagIds
        this.submitData.tagIds = [];
        nvl.forEach((eachValue) => {
          const { id } = this.goodsTagsOption.find((item) => item.value === eachValue);
          if (id > -1) {
            this.submitData.tagIds.push(id);
          }
        });
      },
    },
    /**
     * @description 觀看submitData更新
     */
    submitData: {
      handler(nvl, ovl) {
        this.$emit("submitDataInTabInfoUpdate", nvl);
      },
      deep: true,
    },
  },
  async created() {

  },
  async mounted() {
    this.mountedStatus = true;
    this.initSubmitData();
    this.mountedStatus = false;
    await this.fetchTagsName();
    await this.fetchSelectLeaf();
    this.initInDbTag();
  },
  methods: {
    async wait() {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve()
        }, 2000)
      })
    },
    /**
     * @description 新增規格
     */
    addNewSpec() {

    },
    /**
     * @description 更新submitData
     */
    updateDefaultValue(nvl) {
      console.log("🚀 ~ file: TabInfo.vue:266 ~ updateDefaultValue ~ nvl:", nvl)
      this.$set(this.submitData, 'petCategoryTitle', nvl)
      console.log('nvl');
    },
    /**
     * @description 將原資料陣列改成呈現字串
     */
    composeSeparateSpecString(specArr) {
      return specArr.map((item) => item.join("-")).join(",");
    },
    /**
     * @description 開啟編輯選項圖片
     */
    openEditImgDialog() {
      this.composeEditImgDialogData();
      this.editImg = true;
    },
    /**
     * @description 組成要顯示到「編輯選項圖片」的資料
     */
    composeEditImgDialogData() {
      try {
        const { petSizes } = this.submitData;
        const result = petSizes.reduce((accu, cur) => {
          if (!accu[cur.spec_tag] && cur.state !== 2) {
            accu[cur.spec_tag] = {
              separateSpecArr: this.converSpecTagStr(cur.spec_tag),
              params: cur.params,
              key: cur.spec_tag,
            };
          }
          return accu;
        }, {});
        this.editImgData = Object.values(result);
      } catch (error) {
        console.error(error.message);
      }
    },
    /**
     * @description 修改商品貨號
     */
    changePetSizeNo() {
      if (this.isEditMode && this.compareSubmitDataNo()) {
        this.submitData.petSizes.forEach((item) => {
          item.no = item.no.replace(this.oldSubmitDataNo, this.submitData.no);
        });
        this.oldSubmitDataNo = this.submitData.no; // 把舊的no存起來
      }
    },
    /**
     * @description 比較submitData
     */
    compareSubmitDataNo() {
      if (this.oldSubmitDataNo !== this.submitData.no) {
        return true;
      } else {
        return false;
      }
    },
    /**
     * @description 刪除規格
     */
    deleteSpec(eachSpec) {
      try {
        const deleteItemIndex = this.submitData.spec.findIndex((item) => {
          return item.alias === eachSpec.alias && item.title === eachSpec.title;
        });
        if (deleteItemIndex > -1) {
          const { spec } = this.submitData;
          spec.splice(deleteItemIndex, 1);
        }
      } catch (error) {
        console.error(error.message);
      }
    },
    async wait() {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve();
        }, 2000);
      });
    },
    /**
     * @description 新增規格
     */
    addNewSpec() {
      let { spec } = this.submitData;
      spec.push({
        alias: "",
        title: "",
        inputVisible: false,
        values: [],
      });
    },
    /**
     * @description 更新submitData
     */
    updateDefaultValue(nvl) {
      this.$set(this.submitData, "petCategoryTitle", nvl);
    },
    /**
     * @description 初始化submitData，並設定一些畫面值
     */
    initSubmitData() {
      this.oldSubmitDataNo = this.defaultValue.no;
      this.submitData = cloneDeep(this.defaultValue);
      if (this.isEditMode) {
        if (this.submitData.spec.length > 0) {
          this.submitData.spec.forEach((item) => {
            this.$set(item, "inputVisible", false);
          });
        }
      }
    },
    /**
     * @description 初始化 selectTree下拉選單
     */
    initSelectTree(treeInitData) {
      try {
        this.treeData = this.setLabelFrontForTree(treeInitData);
      } catch (error) {
        console.error(error.message);
      }
    },
    setLabelFrontForTree(nodes, parentLabelFront = "") {
      return nodes.map((node) => {
        const labelFront = parentLabelFront + node.title;
        const clonedNode = { ...node, labelFront };

        if (clonedNode.children && clonedNode.children.length > 0) {
          clonedNode.children = this.setLabelFrontForTree(
            clonedNode.children,
            "" // 這邊是只顯示該層的內容
            // labelFront + ' > ' // 如果要每一個父層都顯示，這邊要打開
          );
        }
        return clonedNode;
      });
    },

    /**
     * @description 初始化標籤名稱
     */
    initInDbTag() {
      if (this.defaultValue.tagIds && this.defaultValue.tagIds.length > 0) {
        this.defaultValue.tagIds.forEach((item) => {
          const idItem = this.goodsTagsOption.find(
            (optionItem) => optionItem.id === item
          );
          if (idItem) {
            this.goodsTagsValue.push(idItem.value);
          }
        });
      }
    },
    /**
     * @description 取得所有標籤中文名稱
     */
    async fetchTagsName() {
      try {
        const { items } = await this.$store.dispatch("mixTag/mixTagSearch", {
          search: "",
          type: "goods",
          paginate: 0,
        });
        this.goodsTagsOption = []; // 先清空選項
        items.forEach((item) => {
          this.goodsTagsOption.push({
            value: item.title,
            label: `${item.title}`,
            id: item.id,
          });
        });
      } catch (error) {
        console.error(error.message);
      }
    },
    /**
     * @description 編輯選項圖片
     */
    cancelSelectProducts() {
      this.editImg = false;
    },
    /**
     * @description 儲存編輯圖片
     */
    saveSelectProducts() {
      try {
        let cloneEditImgData = cloneDeep(this.editImgData);
        cloneEditImgData.forEach((imgItem) => {
          const imgResult = imgItem.params.images.filter((item) => item.path !== null);
          if (imgResult.length > 0) {
            this.$set(imgItem.params, "images", imgResult);
          }
          if (imgResult.length === 0) {
            this.$set(imgItem.params, "images", [
              {
                path: "",
                default: 1,
              },
            ]);
          }
        });
        this.setPetSizesImg(cloneEditImgData);
        this.editImg = false;
      } catch (error) {
        console.error(error.message);
      }
    },
    /**
     * @description 設定petSizes的圖片
     */
    setPetSizesImg(cloneEditImgData) {
      try {
        const { petSizes } = this.submitData;
        petSizes.forEach((petItem) => {
          const imgParams = cloneEditImgData.find(
            (item) => item.key === petItem.spec_tag
          );
          if (imgParams) {
            this.$set(petItem, "params", imgParams.params);
          }
        });
      } catch (error) {
        console.error(error.message);
      }
    },
    /**
     * @description 自動產生貨號
     */
    generateNo() {
      this.$set(this.submitData, "no", this.generateRandomString());
      this.changePetSizeNo();
    },
    /**
     * @description 產生亂數字串
     */
    generateRandomString() {
      const today = new Date();

      // 获取日期部分（年月日）
      const year = today.getFullYear();
      const month = (today.getMonth() + 1).toString().padStart(2, "0"); // 月份需要补零
      const day = today.getDate().toString().padStart(2, "0"); // 日需要补零

      // 生成六位的随机英文字母
      const randomChars = [...Array(6)]
        .map(() => String.fromCharCode(65 + Math.floor(Math.random() * 26)))
        .join("");

      // 获取当前时间部分（时:分:秒）
      const hours = today.getHours().toString().padStart(2, "0");
      const minutes = today.getMinutes().toString().padStart(2, "0");
      const seconds = today.getSeconds().toString().padStart(2, "0");

      // 组合所有部分
      const randomString = `#spec${randomChars}`;
      return randomString;
    },
    addTag() {
      if (this.tagInput) {
        this.tags.push(this.tagInput); // 將輸入框的值新增到標籤陣列中
        this.tagInput = ""; // 清空輸入框
      }
    },
    /**
     * @description 刪除規格
     */
    handleClose(indiSpec, allSpec) {
      allSpec.values = allSpec.values.filter((item) => {
        return item.alias !== indiSpec.alias && item.title !== indiSpec.title;
      });
    },
    /**
     * @description 規格部分，顯示輸入匡
     */
    showInput(eachSpec, eachIndex) {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    /**
     * @description 規格部分，顯示輸入匡
     */
    showSpecInput(eachSpec, eachIndex) {
      if (this.$refs.saveSpecInput && this.$refs.saveSpecInput.length > 0) {
        this.$refs.saveSpecInput.forEach((item) => {
          item.$refs.input.blur();
        });
      }
      this.$set(eachSpec, "inputVisible", !eachSpec.inputVisible);
      this.$nextTick((_) => {
        if (this.$refs.saveSpecInput && this.$refs.saveSpecInput.length > 0) {
          this.$refs.saveSpecInput.forEach((item) => {
            item.$refs.input.focus();
          });
        }
      });
    },
    /**
     * @description 規格手動輸入
     */
    handleSpecConfirm(eachSpec, eachIndex) {
      let specInputValue = this.specInputValue;
      if (specInputValue) {
        eachSpec.values.push({
          alias: `spec${this.generateRandomCode()}`,
          title: specInputValue,
        });
      }
      if (eachSpec.alias === "") {
        this.$set(eachSpec, "alias", `spec${this.generateRandomCode()}`);
      }
      this.$set(eachSpec, "inputVisible", !eachSpec.inputVisible);
      this.specInputValue = "";
    },
    /**
     * @description 產生隨機亂碼
     */
    generateRandomCode() {
      const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      let randomCode = "";

      for (let i = 0; i < 5; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        randomCode += characters.charAt(randomIndex);
      }

      return randomCode;
    },
  },
};
</script>

<style lang="scss" module>
@import "@src/design/layout_detail_steps.scss";

.btnDelete {
  :global {
    .el-button {
      border: 0;
      background-color: #f9f9fb;
      padding: 0;
    }
  }
}

.tagsGlobalSet {
  :global {
    .el-form-item__content {
      background-color: white;
      border-radius: $border-radius;
      border: 1px solid #f4f4f4;
      padding-left: 18px;
      padding-bottom: 2px;
      padding-top: 2px;
    }

    .el-tag {
      border-radius: $border-radius;
      background-color: $color-input-bg;
      color: black;
      border: 1px solid $color-input-bg;
    }

    .el-tag+.el-tag {
      margin-left: 10px;
    }

    .el-icon-close {
      color: $color-text-placeholder;
    }

    .button-new-tag {
      margin-left: 10px;
      height: 32px;
      line-height: 30px;
      padding-top: 0;
      padding-bottom: 0;
      border-radius: $border-radius;
    }

    .input-new-tag {
      width: 90px;
      margin-left: 10px;
      vertical-align: bottom;

      :global {
        .el-input__inner {
          height: 32px;
        }
      }
    }
  }
}

.form {
  display: inline-block;
  height: 100%;
  width: 100%;

  :global {
    .el-input-group__prepend {
      padding-left: 0;
    }

    .titleAndBtnDisplay {
      display: flex;
      justify-content: space-between;
    }

    .formatContentSet {
      margin-top: 32px;
      padding-top: 20px;
      padding-left: 20px;
      padding-right: 20px;
      background-color: #f9f9fb;
      display: flex;
      align-items: flex-start;
      justify-content: space-around;

      >* {
        margin-left: 10px;
        margin-right: 10px;
      }

      :global {
        .tagsSelect {
          flex-grow: 1;
        }
      }
    }

    .fullWidthBtn {
      margin-top: 18px;
      width: 100%;
      border-radius: $border-radius;
    }
  }
}

%img-size {
  width: 100%;
  height: 220px;

  @include max-sm {
    width: calc(100% - 10px);
  }
}

:global {
  :local(.upload) {
    border-top: none !important;

    >div {
      @extend %img-size;
    }

    .image-and-action {
      @extend %img-size;

      &+div {
        @extend %img-size;
      }
    }
  }
}

.rightText {
  margin-bottom: 50px;

  :global {
    .el-form-item__content>p {
      margin: 0;
      line-height: 20px;
    }
  }
}

.imgPositionB {
  display: flex;
  align-items: flex-end;
}

.imgProductImg {
  display: flex;
  align-items: center;
}

.childFormat {
  display: flex;
  margin-top: 32px;

  :global {
    .formatContentSet {
      margin-left: 20px;
      margin-top: 0;
      flex-grow: 1; // 這邊會造成整行填滿
    }
  }
}

.webAnalyze {
  display: flex;
  align-items: flex-end;
  padding-left: 20px;
  padding-right: 20px;
  background-color: $color-line;
  margin-top: 18px;

  :global {
    .el-form-item {
      &:nth-child(2) {
        margin-left: 20px;
        margin-right: 20px;
        flex-grow: 1;
      }
    }
  }
}

.imgDialog {
  :global {
    .el-table__body-wrapper {
      margin-top: 10px;
      margin-bottom: 30px;
    }

    .el-table__body .el-table__row {
      background-color: $color-line;
    }
  }
}

.goodsTagStyle {
  :global {
    .el-form-item__content {
      background-color: white;
      border-radius: $border-radius;
    }
  }
}

.productTagsStyle {
  :global {
    .el-form-item__content {
      border: 1px solid $color-line-dark;
      border-radius: $border-radius;
    }
  }
}
</style>
